import { Dialog as MuiDialog, DialogProps as MuiDialogProps, Slide as MuiSlide } from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions';
import React, { forwardRef, ReactElement, ReactNode, Ref } from 'react';

import { WithStyles, withStyles } from '@core/theme/utils/with-styles';
import { ModalBody, ModalFooter, ModalHeader } from '@shared/components/overlay';
import { ContainerWidths } from '@shared/constants/common';
import { t } from '@shared/i18n';
import { ButtonColour, ButtonSize } from '@shared/types/common/button';

import { styles } from './UnsavedChangesModal.styles';

const ModalTransition = forwardRef(
  (props: TransitionProps & { children?: ReactElement<any, any> }, ref: Ref<unknown>) => (
    <MuiSlide direction="down" ref={ref} {...props} />
  )
);

export interface UnsavedChangesModalProps
  extends Omit<MuiDialogProps, 'classes' | 'PaperProps' | 'ref' | 'TransitionComponent' | 'onClose'>,
    WithStyles<typeof styles> {
  content?: ReactNode;
  labelCancel?: string;
  labelConfirm?: string;
  width?: ContainerWidths;
  withTransition?: boolean;
  onCancel: () => any;
  onConfirm: () => any;
}

const UnsavedChangesModalComponent: React.FC<UnsavedChangesModalProps> = ({
  classes,
  content,
  labelCancel,
  labelConfirm,
  width,
  withTransition,
  onCancel,
  onConfirm,
  ...dialogProps
}) => {
  return (
    <MuiDialog
      {...dialogProps}
      classes={{ root: classes.root, paper: classes.paper }}
      PaperProps={{ style: { maxWidth: width ?? ContainerWidths.sm } }}
      {...(withTransition && { TransitionComponent: ModalTransition })}
      onClose={onCancel}
    >
      <ModalHeader heading={t('unsaved_changes')} />
      <ModalBody>{content ?? t('you_have_unsaved_changes_do_you_want_to_continue_without_saving_question')}</ModalBody>
      <ModalFooter
        buttonsRight={[
          {
            size: ButtonSize.small,
            text: labelCancel ?? t('cancel'),
            onClick: onCancel,
          },
          {
            colour: ButtonColour.primary,
            size: ButtonSize.small,
            text: labelConfirm ?? t('continue'),
            onClick: onConfirm,
          },
        ]}
      />
    </MuiDialog>
  );
};

export const UnsavedChangesModal = withStyles(styles)(UnsavedChangesModalComponent);
